<template>
  <div class="editor-container">
    <we-editor
      :toolbar-option="toolbar"
      :editable-option="editable"
      :html.sync="editorContent"
    />
  </div>
</template>

<script>
import { useWangEditor } from 'wangeditor5-for-vue2'

export default {
  name: 'WangEditor',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorContent: this.value,
      ...useWangEditor({
        config: {
          placeholder: '请输入内容...',
          onCreated: (editor) => {
            // 编辑器创建完成时的回调
            console.log('editor created', editor)
          },
          onChange: (editor) => {
            // 编辑器内容变化时的回调
            console.log('editor content changed', editor.getHtml())
          }
        }
      })
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val !== this.editorContent) {
          this.editorContent = val
        }
      },
      immediate: true
    },
    editorContent: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  }
}
</script>

<style>
.editor-container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
}

/* 工具栏样式 */
.w-e-toolbar {
  border-bottom: 1px solid #dcdfe6 !important;
  padding: 5px !important;
  background-color: #fafafa !important;
  border-radius: 4px 4px 0 0;
}

/* 编辑区域样式 */
.w-e-text-container {
  background-color: #fff !important;
  border: none !important;
  height: 400px !important; /* 设置固定高度 */
}

/* 编辑区域文本样式 */
.w-e-text {
  height: 100% !important;
  padding: 12px !important;
  overflow-y: auto !important; /* 添加垂直滚动条 */
}

/* 工具栏按钮样式 */
.w-e-bar-item {
  padding: 4px 6px !important;
  border-radius: 3px;
}

/* 工具栏按钮悬停效果 */
.w-e-toolbar .w-e-bar-item:hover {
  background-color: #ecf5ff !important;
}

/* 编辑器聚焦时的样式 */
.editor-container:focus-within {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}
</style>